export enum Role {
  ADMIN = 'ADMIN',
  UTILISATEUR = 'UTILISATEUR',
}

